import React from "react"
import { useKeenSlider } from "keen-slider/react"
import "keen-slider/keen-slider.min.css"
import Lightbox from "react-images"
import useIsMobile from "../Hooks/useIsMobile"

const ProductImageSlideshow = props => {
    const { images } = props
    const [activeImageIndex, setActiveImageIndex] = React.useState(null)
    const [isLightboxOpen, setIsLightboxOpen] = React.useState(false)
    const [currentLightboxImage, setCurrentLightboxImage] = React.useState(null)
    const isMobile = useIsMobile()

    const [sliderRef, slider] = useKeenSlider({
        loop: true,
        slideChanged: (s) => setActiveImageIndex(s.details().relativeSlide),
    })
    
    const openCurrentImage = () => {
        if(activeImageIndex == null)
            return
        setCurrentLightboxImage(activeImageIndex)
        setIsLightboxOpen(true)
    }

    const getLightboxImages = () => images.map(img => ({ src: img.original }))

    return <>
        <div className="product-images__zoom-icon" onClick={openCurrentImage}>
            <i className="far fa-search-plus fa-lg"></i>
        </div>
        <div className="product-images keen-slider" ref={sliderRef}>
            {images.map((image, i) => <div className="keen-slider__slide" key={i+image.src}>
                <img src={image.src} onClick={openCurrentImage} />
              </div>
            )}
        </div>
        {isMobile && slider && 
            <>
                <button className="product-images__arrow product-images__arrow--left" onClick={() => slider.prev()}>
                    <i className="fas fa-chevron-left fa-lg"></i>
                </button>
                <button className="product-images__arrow product-images__arrow--right" onClick={() => slider.next()}>
                    <i className="fas fa-chevron-right fa-lg"></i>
                </button>
            </>
        }
        <div className="product-images__thumbnails">
            {!isMobile && images.map((image, i) =>
                <img key={i+image.thumbnail} src={image.thumbnail} onClick={() => slider.moveToSlideRelative(i)}
                    className={["product-images__thumbnail", i == activeImageIndex ? "product-images__thumbnail--active" : ""].join(" ")} 
                />
            )}
            {isMobile && slider && 
                [...Array(slider.details().size).keys()].map((i) => {
                    return (
                        <button
                            key={i}
                            onClick={() => slider.moveToSlideRelative(i)}
                            className={["product-images__thumbnail--dot", activeImageIndex === i ? "product-images__thumbnail--active" : ""].join(" ")}
                        />
                    )
                }
            )}
        </div>
        <Lightbox
            images={getLightboxImages()}
            onClickPrev={() => setCurrentLightboxImage(currentLightboxImage-1)}
            onClickNext={() => setCurrentLightboxImage(currentLightboxImage+1)}
            currentImage={currentLightboxImage}
            backdropClosesModal={true} 
            isOpen={isLightboxOpen}
            onClose={() => setIsLightboxOpen(false)} />
    </>
}

export default ProductImageSlideshow